import * as angular from 'angular';
import * as _ from 'lodash';

import { IDashboardService } from '../../services';
import { Store } from '../Store';
import * as DASHBOARDUSERS from './dashboardUsers.constants';

import {
    loadDashboardUsers,
    loadDashboardUsersSuccess
} from './dashboardUsers.actions';
import { ObjectUser, DashboardUsers } from '../../models';

export interface IDashboardUserActionsService {
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<DashboardUsers>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<DashboardUsers>;
}

export class DashboardUsersActionsService implements IDashboardUserActionsService {

    static serviceId = 'dashboardUserActionsService';
    static $inject = ['$q', 'dashboardService'];


    constructor(
        private _$q: angular.IQService,
        private _dashboardService: IDashboardService) {
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { dashboardUsers } = getState();
            if (force || (!dashboardUsers.isLoading && !dashboardUsers.isLoaded)) {
                dispatch(loadDashboardUsers());
                return this._dashboardService.getAllUsers(force)
                    .then(data => {
                        dispatch(loadDashboardUsersSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: DASHBOARDUSERS.DASHBOARD_USERS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<ObjectUser>(dashboardUsers.dictionary));
            }
        };
    }
}